import isDate from 'lodash-es/isDate';
import isObject from 'lodash-es/isObject';
import isEmpty from 'lodash-es/isEmpty';
import get from 'lodash-es/get';

const properObject = o => (isObject(o) && !o.hasOwnProperty ? { ...o } : o);

const diff = (lhs, rhs) => {
  if (
    get(rhs, 'group.type') === 'ludusPathGroup' ||
    get(lhs, 'group.type') === 'ludusPathGroup'
  ) {
    // dont check child of groups
    return {};
  }
  if (lhs === rhs) return {}; // equal return no diff

  if (!isObject(lhs) || !isObject(rhs)) return rhs; // return updated rhs

  const l = properObject(lhs);
  const r = properObject(rhs);
  /* eslint-disable no-prototype-builtins */
  const deletedValues = Object.keys(l).reduce((acc, key) => {
    return r.hasOwnProperty(key) ? acc : { ...acc, [key]: null };
  }, {});

  if (isDate(l) || isDate(r)) {
    if (l.valueOf() === r.valueOf()) return {};
    return r;
  }

  return Object.keys(r).reduce((acc, key) => {
    if (key === 'contents') {
      if (Array.isArray(l[key])) {
        return { ...acc, [key]: r[key] };
      }
    }
    // if (rhs.type === 'ludusPathGroup' && key === 'objects') {
    //   return acc;
    // }
    if (!l[key] && !r[key]) return acc; // prevent null vs undefined being different
    if (key === 'path' || key === '_objects' || key === 'points') {
      // dont check childs of active or points of brush
      return acc;
    }
    if (!l.hasOwnProperty(key)) return { ...acc, [key]: r[key] }; // return added r key

    const difference = diff(l[key], r[key]);

    if (isObject(difference) && isEmpty(difference) && !isDate(difference))
      return acc; // return no diff

    return { ...acc, [key]: difference }; // return updated key
  }, deletedValues);
};

export default diff;
